import { jsx, jsxs } from 'react/jsx-runtime';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-avatar.css';
import * as React from 'react';

const getClassNameList$1 = classNames.bind(styles);
const EGDSAvatarGroupContext = React.createContext({});
const EGDSAvatarGroup = (props) => {
    const { size, items, children, overflow } = props;
    const baseAvatarGroupClass = 'uitk-avatar-group';
    const avatarGroupClassNames = getClassNameList$1(baseAvatarGroupClass, `${baseAvatarGroupClass}-${size}`);
    const contextProviderValue = React.useMemo(() => ({ size, border: true }), [size]);
    const renderOverflowIcon = (count) => jsx(EGDSAvatarGroupItem, { text: `${count}+` }, "uitk-overflow-icon");
    const renderChildren = () => {
        const childrenArray = React.Children.toArray(children);
        const overflowChildren = childrenArray && overflow && childrenArray.length > overflow;
        const overflowCount = childrenArray && overflow && childrenArray.length - overflow;
        const newChildren = overflowChildren ? childrenArray.slice(0, overflow) : childrenArray;
        if (overflowChildren && overflowCount) {
            newChildren.push(renderOverflowIcon(overflowCount));
        }
        return newChildren;
    };
    const renderItems = () => {
        const overflowItems = items && overflow && items?.length > overflow;
        const overflowCount = items && overflow && items.length - overflow;
        const newChildrenFromProps = [];
        const newItems = overflowItems ? items?.slice(0, overflow) : items;
        newItems?.forEach((item, idx) => {
            newChildrenFromProps.push(jsx(EGDSAvatarGroupItem, { ...item }, idx));
        });
        if (overflowItems && overflowCount) {
            newChildrenFromProps.push(renderOverflowIcon(overflowCount));
        }
        return newChildrenFromProps;
    };
    return (jsx("ul", { className: avatarGroupClassNames, children: jsx(EGDSAvatarGroupContext.Provider, { value: contextProviderValue, children: (!items && renderChildren()) || renderItems() || null }) }));
};
EGDSAvatarGroup.defaultProps = {
    size: 'medium',
    overflow: 4,
};
EGDSAvatarGroup.displayName = 'EGDSAvatarGroup';

const getClassNameList = classNames.bind(styles);
const EGDSAvatar = (props) => {
    const { border, size, image, text, icon, className } = props;
    const baseCssClass = 'uitk-avatar';
    const avatarClassNames = getClassNameList(baseCssClass, {
        [`${baseCssClass}-${size}`]: size,
    }, {
        [`${baseCssClass}-hasborder`]: border,
    }, className);
    /**
     * Outputs a string with a period placed between each character.
     * Designed to be visually hidden, for screenreaders only
     * @param text
     * @returns string
     */
    const makea11yLabelForText = (text) => {
        let a11yLabel = '';
        Array.from(text).forEach((char) => {
            a11yLabel += `${char}.`;
        });
        return a11yLabel;
    };
    const renderContent = () => {
        if (image) {
            return (jsx("img", { className: getClassNameList(avatarClassNames, `${baseCssClass}-image`), src: image.src, alt: image.alt }));
        }
        if (text) {
            return (jsxs("div", { className: getClassNameList(avatarClassNames, `${baseCssClass}-text`, `${baseCssClass}-text-${size}`), children: [jsx("span", { "aria-hidden": true, children: text }), jsx("span", { className: "is-visually-hidden", children: makea11yLabelForText(text) })] }));
        }
        if (icon) {
            return (jsx("div", { className: getClassNameList(avatarClassNames, `${baseCssClass}-icon`, `${baseCssClass}-icon-${size}`), children: jsx(EGDSIcon, { name: icon }) }));
        }
        return jsx("div", { className: getClassNameList(avatarClassNames, `${baseCssClass}-placeholder`) });
    };
    return renderContent();
};
const withSizeAndBorder = (Component) => {
    const SizeAndBorderComponent = (props) => (jsx(EGDSAvatarGroupContext.Consumer, { children: ({ size, border }) => jsx(Component, { ...props, size: size, border: border }) }));
    return SizeAndBorderComponent;
};
const EGDSAvatarGroupItem = (props) => {
    const AvatarSized = withSizeAndBorder(EGDSAvatar);
    return (jsx("li", { className: getClassNameList(`uitk-avatar-group-item`), children: jsx(AvatarSized, { ...props }) }));
};
EGDSAvatar.defaultProps = {
    size: 'medium',
    border: false,
};
EGDSAvatar.displayName = 'EGDSAvatar';

export { EGDSAvatar as E, EGDSAvatarGroupItem as a, EGDSAvatarGroup as b };
//# sourceMappingURL=index-chunk.esm.js.map
